/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { RouteComponentProps } from 'react-router'
import { ISectionStateManager, ISectionArticleList } from '../../services/SectionStateManager/contracts'
import { observer } from 'mobx-react'
import React from 'react'
import './Section.scss'
import { Link } from 'react-router-dom'
import { SettingsManager } from '../../configuration/SettingsManager'
import PropTypes from 'prop-types'
import { UserEventLogger } from '../../utils/UserEventLogger'

export interface ISectionProps extends RouteComponentProps<any> {
	productCode: string
	sectionName: string
	loadContentInformation: any
}

export interface ISectionState {
	sectionArticles: ISectionArticleList | null
}

export class Section extends React.Component<any, ISectionState> {
	constructor(props: Readonly<ISectionProps>) {
		super(props)
		this.state = {
			sectionArticles: null,
		}
	}
	componentDidMount() {
		(this.props.sectionStateManager.getSectionArticles(this.props.productCode, this.props.sectionName) as Promise<ISectionArticleList>).then(response => this.setState({ sectionArticles: response }))
	}

	componentDidUpdate(prevSectionName: any) {
		if (this.props.sectionName != prevSectionName.sectionName) {
			(this.props.sectionStateManager.getSectionArticles(this.props.productCode, this.props.sectionName) as Promise<ISectionArticleList>).then(response => this.setState({ sectionArticles: response }))
		}
	}
	onArticleChange(contentItemId: any) {
		this.props.loadContentInformation(contentItemId)
	}

	handleArticleLinkClick(event: any, isPdf: boolean) {
		if (isPdf) {
			UserEventLogger.handleUserClickEvent(event, 'SupportSite - Section Page Article PDF Link Click', '')
		} else {
			UserEventLogger.handleUserClickEvent(event, 'SupportSite - Section Page Article Link Click', '')
		}
	}

	render() {
		const model = this.state.sectionArticles
		if (!model) {
			return null
		}
		const actualSectionName = model.total > 0 ? model.items[0].sectionName : ''
		return (
			<div className="items-grid col">
				<div className="article-result">
					<span className="prod-header">{actualSectionName}</span>
				</div>
				{model.items.map((article: any, index: number) =>
					article.IsPdf ? (
						<div className="row article-link" key={index}>
							<a
								target="_blank"
								className="word-brak-a"
								href={`${SettingsManager.REACT_APP_MAIN_CMS_BASE_URL().value}` + article.sectionArticlePath}
								onClick={e => {
									this.handleArticleLinkClick(e, true)
								}}
							>
								{article.sectionArticleName}
							</a>
						</div>
					) : (
						<div className="row article-link" key={index}>
							<Link
								className="word-brak-a"
								to={'/help/pages/' + article.sectionArticlePath}
								onClick={e => {
									this.handleArticleLinkClick(e, false)
								}}
							>
								{' '}
								{article.sectionArticleName}
							</Link>
						</div>
					),
				)}
			</div>
		)
	}
}
